module.exports = __webpack_public_path__ + "media/4x3/ms-e147bd2b.svg";